import React, { useContext, useState } from "react";
import { TextField, MenuItem,Button } from "@mui/material";
import { ContextData } from "../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../BaseURL";
import SoundAlert from "../../../../../routes/SoundAlert";

function BankDetails({ formData }) {


    const { UserTokens, ReloadBioForms, setReloadBioForms } = useContext(ContextData);
    const [formDatas, setFormDatas] = useState({
        bank_name: formData.bank.bank_name || "",
        account_number: formData.bank.account_number || "",
        account_name: formData.bank.account_name || "",
        bvn_number : formData.bank.bvn_number || "",
        tin_number : formData.bank.tin_number || "",
        nin_number : formData.bank.nin_number || "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDatas((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = (type) => {

                    
                     
                    
                    if(type === "bank_name"){
              
                      
                      if ( formDatas.bank_name === "") {
                               SoundAlert("error")
                        toast.error('Please fill in all required fields.');
                          return
                      }
              
                    }


                    if(type === "account_number"){
              
                       
                        if ( formDatas.account_number === "") {
                              SoundAlert("error")          
                          toast.error('Please fill in all required fields.');
                            return
                        }
                
                      }


                      if(type === "account_name"){
              
                         
                        if ( formDatas.account_name === "") {
                                 SoundAlert("error")
                          toast.error('Please fill in all required fields.');
                            return
                        }
                
                      }

                      if(type === "bvn_number"){
              
                        
                        if ( formDatas.bvn_number === "") {
                                 SoundAlert("error")
                          toast.error('Please fill in all required fields.');
                            return
                        }
                
                      }

                      if(type === "tin_number"){
              
                          
                        if ( formDatas.tin_number === "") {
                                 SoundAlert("error")
                          toast.error('Please fill in all required fields.');
                            return
                        }
                
                      }

                      if(type === "nin_number"){
              
                       
                        if ( formDatas.nin_number === "") {
                                    SoundAlert("error")
                          toast.error('Please fill in all required fields.');
                            return
                        }
                
                      }

                      if ((type === "account_name" && !/^[a-zA-Z\s]+$/.test(formDatas.account_name)) && formDatas.account_name !== "") {
                          SoundAlert("error")
                          toast.error('Account name must contain only letters and spaces.');
                          return;
                      }


        // check if is numeric
        if ((type === "account_number" && isNaN(formDatas.account_number)) && formDatas.account_number !== "") {
            SoundAlert("error")
            toast.error('Account number must be numeric.');
            return;
        }
        if ((type === "bvn_number" && isNaN(formDatas.bvn_number)) && formDatas.bvn_number !== "") {
            SoundAlert("error")
            toast.error('BVN number must be numeric.');
            return;
        }
        if ((type === "tin_number" && isNaN(formDatas.tin_number)) && formDatas.tin_number !== "") {
            SoundAlert("error")
            toast.error('TIN number must be numeric.');
            return;
        }
        if ((type === "nin_number" && isNaN(formDatas.nin_number)) && formDatas.nin_number !== "") {
            SoundAlert("error")
            toast.error('NIN number must be numeric.');
            return;
        }

       if(type === "tin_number_na"){

         setFormDatas(prev=>({
             ...prev,
             tin_number: "N/A"
         }))
           
       }

                    
        axios.put(`${baseUrl}/auth/bank_details_update`, { ...formDatas, user_token: UserTokens }, {
            withCredentials: true,
            headers: {
                'Accept': 'application/json'
            }
        }).then(res => {
            if (res.data.status) {
                SoundAlert("success")
                toast.success(res.data.textStatus);
                setReloadBioForms(!ReloadBioForms);
            }
        }).catch(err => {
            if (err) {
                toast.error(err.message);
                console.log(err);
                return;
            }
        });
    };




    return (
        <div>
            <TextField
                label="Bank Name"
                name="bank_name"
                value={formDatas.bank_name}
                onChange={handleChange}
                fullWidth
                margin="dense"
                required
                InputProps={{
                    endAdornment: (
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => handleSubmit("bank_name")}
                        >
                            Save
                        </Button>
                    )
                }}
            />
            <TextField
                label="Account Number"
                name="account_number"
                value={formDatas.account_number}
                onChange={handleChange}
                fullWidth
                margin="dense"
                required
                inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
                InputProps={{
                    endAdornment: (
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => handleSubmit("account_number")}
                        >
                            Save
                        </Button>
                    ),
                    
                }}
            />
            <TextField
                label="Account Name"
                name="account_name"
                value={formDatas.account_name}
                onChange={handleChange}
                fullWidth
                margin="dense"
                required
                InputProps={{
                    endAdornment: (
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => handleSubmit("account_name")}
                        >
                            Save
                        </Button>
                    ),
                    
                }}
            />
            <TextField
                label="BVN Number"
                name="bvn_number"
                value={formDatas.bvn_number}
                onChange={handleChange}
                fullWidth
                margin="dense"
                required
                inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
                InputProps={{
                    endAdornment: (
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => handleSubmit("bvn_number")}
                            >
                            Save
                        </Button>
                    ),
                    
                }}
            />
            <TextField
                label="TIN Number Optional"
                name="tin_number"
                value={formDatas.tin_number}
                onChange={handleChange}
                fullWidth
                margin="dense"
                required
                InputProps={{
                    endAdornment: (

                         <div className="flex"> 
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => handleSubmit("tin_number")}
                            
                        >
                            Save
                        </Button>  
                        



                         </div>
                    )
                }}
            />
            <TextField
                label="NIN Number" 
                name="nin_number"
                value={formDatas.nin_number}
                onChange={handleChange}
                fullWidth
                margin="dense"
                required
                inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
                InputProps={{
                    endAdornment: (
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => handleSubmit("nin_number")}
                        >
                            Save
                        </Button>
                    ),
                    
                }}
            />
            
        </div>
    );
}

export default BankDetails;
